// @flow

import { createActions } from 'redux-actions';
import { MACHETE_NS } from './constants';

export const CREATE_MODELS = `${MACHETE_NS}/MODEL/CREATE_MODELS`;
export const CREATE_ORIGINAL_MODEL = `${MACHETE_NS}/MODEL/CREATE_ORIGINAL_MODEL`;
export const CREATE_SAVED_MODEL = `${MACHETE_NS}/MODEL/CREATE_SAVED_MODEL`;
export const FOCUS = `${MACHETE_NS}/MODEL/FOCUS`;
export const LOAD = `${MACHETE_NS}/MODEL/LOAD`;
export const LOAD_ELEMENTS = `${MACHETE_NS}/MODEL/LOAD_ELEMENTS`;
export const ON_ELEMENT_ADDED = `${MACHETE_NS}/MODEL/ON_ELEMENT_ADDED`;
export const ON_ELEMENT_REMOVED = `${MACHETE_NS}/MODEL/ON_ELEMENT_REMOVED`;
export const READY = `${MACHETE_NS}/MODEL/READY`;
export const RESET_MODEL = `${MACHETE_NS}/MODEL/RESET_MODEL`;
export const SELECT_AND_SHOW_MODEL = `${MACHETE_NS}/MODEL/SELECT_AND_SHOW_MODEL`;
export const SET_DEFAULT_OPACITY_FOR_FACADES = `${MACHETE_NS}/MODEL/SET_DEFAULT_OPACITY_FOR_FACADES`;
export const TOGGLE_MEASURE_TOOL = `${MACHETE_NS}/MODEL/TOGGLE_MEASURE_TOOL`;

const actions = createActions({
  [CREATE_MODELS]: (models, textures) => ({ models, textures }),
  [CREATE_ORIGINAL_MODEL]: (opts) => ({ opts }),
  [CREATE_SAVED_MODEL]: (opts) => ({ opts }),
  [FOCUS]: () => null,
  [LOAD_ELEMENTS]: (elements) => ({ elements }),
  [LOAD]: ({ options }) => ({ options }),
  [ON_ELEMENT_ADDED]: (event) => ({ event }),
  [ON_ELEMENT_REMOVED]: (event) => ({ event }),
  [READY]: (model) => ({ model }),
  [RESET_MODEL]: (id) => ({ id }),
  [SELECT_AND_SHOW_MODEL]: (model) => ({ model }),
  [SET_DEFAULT_OPACITY_FOR_FACADES]: (facadeOpacity) => ({ facadeOpacity }),
  [TOGGLE_MEASURE_TOOL]: () => null,
});

export default actions.machete.model;
